"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chevron_small_right = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const chevron_small_right = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'chevron-small-right-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.46967 15.1494C7.17678 14.8565 7.17678 14.3816 7.46967 14.0887L10.9393 10.6191L7.46967 7.14941C7.17678 6.85652 7.17678 6.38164 7.46967 6.08875C7.76256 5.79586 8.23744 5.79586 8.53033 6.08875L12.5303 10.0887C12.671 10.2294 12.75 10.4202 12.75 10.6191C12.75 10.818 12.671 11.0088 12.5303 11.1494L8.53033 15.1494C8.23744 15.4423 7.76256 15.4423 7.46967 15.1494Z', fill: '#4B5563' })));
};
exports.chevron_small_right = chevron_small_right;
